import { render, staticRenderFns } from "./ScreenGroupsView.vue?vue&type=template&id=4648bf53&"
import script from "./ScreenGroupsView.vue?vue&type=script&lang=js&"
export * from "./ScreenGroupsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports